<template>
    <div>
      <div class="container ">
        <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-2">
            <div class="btn-group btn-home me-2">
                <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackCampus">
                    <i class="fas fa-recycle"></i> Cambiar de Sede
                </button>
            </div>
        </div>
        <div id="btn_home" class="c-app align-items-center">
          <div class="d-grid gap-2 mx-auto text-center col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <h2>HOME LOGISTICA</h2>  
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'homeMaintenance',
    data() {
        return {
            page: null
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page)
        },
        mtdBackCampus: function () {
            this.$emit('mtdBackCampus')
        },
        mtdCloseBead() {
            this.$emit("changePage", "reporteClose");
        }
    }
}
</script>

<style>
@media (max-width: 415px) {
    #scroll-div {
        height: 140px;
    }
}
@media (max-width: 1024px) {
  #scroll-div {
    /*height: 200px;*/
    height: 280px;
  }
}
@media (max-width: 768px) {
  #scroll-div {
    /*height: 170px;*/
    height: 220px;
  }
}

</style>
